import initialState from "./blogState";

const blogReducer = (state = initialState, action) => {
  return state;
};

export default blogReducer;
